import type { HTMLMotionProps, VariantLabels } from 'motion/react';
import { motion } from 'motion/react';
import React from 'react';

const BASE_TRANSITION = {
  type: 'tween',
  duration: 0.1,
} as const;

type WithoutNonObjectTypes<Keys extends keyof HTMLMotionProps<'div'>> = {
  [Key in Keys]: Exclude<HTMLMotionProps<'div'>[Key], boolean | VariantLabels>;
};

type OpacityMotionTransitionProps = Omit<
  HTMLMotionProps<'div'>,
  'initial' | 'animate' | 'exit'
> &
  Partial<WithoutNonObjectTypes<'initial' | 'animate' | 'exit'>> & {
    disabled?: boolean;
  };

const OpacityMotionTransition = ({
  children,
  transition,
  initial,
  animate,
  exit,
  disabled,
  ...rest
}: OpacityMotionTransitionProps) => {
  return (
    <motion.div
      initial={{
        opacity: 0,
        ...initial,
      }}
      animate={{
        opacity: 1,
        ...animate,
      }}
      exit={{
        opacity: 0,
        ...exit,
      }}
      transition={
        disabled ? { duration: 0 } : { ...BASE_TRANSITION, ...transition }
      }
      {...rest}
    >
      {children}
    </motion.div>
  );
};

export default OpacityMotionTransition;
